import { Box, Grid, GridItem } from "@chakra-ui/react";
import React, { Fragment, useContext, useLayoutEffect, useRef, useState, } from "react";
import { useHotkeys } from "react-hotkeys-hook";
import { AnimationsModal } from "./Animations/AnimationsModal";
import { LayoutItemDetail } from "./LayoutItem/LayoutItemDetail";
import { LayoutLateralMenu } from "./LateralMenu/LayoutLateralMenu";
import { Player } from "./Player";
import { StudioContext } from "./studioContext";
import { useServices } from "./hooks/useServices";
const EDITOR_PADDING = 24;
export const StudioEditor = () => {
    var _a;
    const [playerHeight, setPlayerHeight] = useState(0);
    const [playerWidth, setPlayerWidth] = useState(0);
    const [selectedTab, setSelectedTab] = useState("Zones");
    const ref = useRef(null);
    const playerContainerRef = useRef(null);
    const { layoutService } = useServices();
    const { widgets, isLocked, screenHeight, screenWidth, layoutItems, selectedLayoutItemId, } = useContext(StudioContext);
    const layoutItem = layoutItems.find((item) => item.id === selectedLayoutItemId);
    useHotkeys("backspace, del", () => {
        if (isLocked)
            return;
        if (!layoutItem)
            return;
        layoutService.removeLayoutItem(layoutItem);
    }, [layoutItem, isLocked]);
    useHotkeys("escape", () => {
        layoutService.selectLayoutItem(null);
    });
    const widget = widgets.find((widget) => widget.name === (layoutItem === null || layoutItem === void 0 ? void 0 : layoutItem.widgetName));
    const WidgetContextProvider = (widget === null || widget === void 0 ? void 0 : widget.context) || Fragment;
    useLayoutEffect(() => {
        var _a, _b;
        const playerTop = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().top;
        const playerWidth = (_b = playerContainerRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().width;
        const windowHeight = window.innerHeight;
        if (playerWidth && playerWidth > 0) {
            setPlayerWidth(playerWidth);
        }
        if (playerTop !== null) {
            console.log(playerTop);
            if (!playerTop) {
                console.log("undefined", playerTop);
                return;
            }
            setPlayerHeight(windowHeight - playerTop - EDITOR_PADDING * 2);
        }
    }, []);
    return (React.createElement(Box, { ref: ref, bg: "white", borderRadius: 12, width: "100%", padding: `${EDITOR_PADDING}px`, height: "100%" },
        React.createElement(AnimationsModal, null),
        (widget === null || widget === void 0 ? void 0 : widget.context) ? (React.createElement(WidgetContextProvider, { key: `widget-provider-${(_a = layoutItem === null || layoutItem === void 0 ? void 0 : layoutItem.id) !== null && _a !== void 0 ? _a : Math.random().toString(36)}`, selectedLayoutItemId: selectedLayoutItemId, data: layoutItem === null || layoutItem === void 0 ? void 0 : layoutItem.widget.data },
            React.createElement(Grid, { templateColumns: "250px 1fr 250px", gap: "24px", height: "100%" },
                React.createElement(GridItem, null,
                    React.createElement(LayoutLateralMenu, { layoutItems: layoutItems, selectedLayoutItemId: selectedLayoutItemId, selectedTab: selectedTab, setSelectedTab: setSelectedTab, isLocked: isLocked, screenHeight: screenHeight, screenWidth: screenWidth, widgets: widgets })),
                React.createElement(GridItem, { ref: playerContainerRef, height: "100%", overflow: "hidden" },
                    React.createElement(Player, { playerWidth: playerWidth, playerHeight: playerHeight })),
                React.createElement(GridItem, null,
                    React.createElement(LayoutItemDetail, null))))) : (React.createElement(React.Fragment, null,
            React.createElement(Grid, { templateColumns: "250px 1fr 250px", gap: "24px", height: "100%" },
                React.createElement(GridItem, null,
                    React.createElement(LayoutLateralMenu, { layoutItems: layoutItems, selectedLayoutItemId: selectedLayoutItemId, selectedTab: selectedTab, setSelectedTab: setSelectedTab, isLocked: isLocked, screenHeight: screenHeight, screenWidth: screenWidth, widgets: widgets })),
                React.createElement(GridItem, { ref: playerContainerRef, height: "100%", overflow: "hidden" },
                    React.createElement(Player, { playerWidth: playerWidth, playerHeight: playerHeight })),
                React.createElement(GridItem, null,
                    React.createElement(LayoutItemDetail, null)))))));
};
